"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//https://pbo.wixpress.com/rpc-console-poc/wix-apps-webapp/app-jvm-137.42.wixprod.net/tpaDistributionService/getPublicApp?WyIzODM2YWUxOS04MDA0LTQyMmMtOTBhNC1hZWJlNzBhYWE0MjQiXQ==.e30=
exports.GROUPS_WIDGET_ID = 'a7dcdfcb-8abd-4008-af19-fed5fcd12b40';
exports.GROUPS_LIST_WIDGET_ID = '0a9f687f-7e00-4576-a8e1-9415844b8f44';
exports.GROUP_WIDGET_ID = '513a5d84-3ebb-4ca6-a5aa-83effd2123b9';
exports.CONTEXT_CALLBACKS_APP_ID = 'c0b88324-5294-4255-a601-0e426091c233';
//# sourceMappingURL=constants.js.map